export default "__VITE_ASSET__HYV_Kbf9__"